(function () {
  // =========================
  // ✅ Einstellungen
  // =========================
  const ONLY_HOMEPAGE = true;                 // nur Startseite
  const REPEAT_AFTER_DAYS = 7;                // nach 7 Tagen wieder
  const STORAGE_KEY = "pvx_seen_ts";          // Speicher-Key

  function isHomePage() {
    // Shopify hat meistens body-Klasse "template-index" auf der Startseite
    const byClass = document.body && document.body.classList.contains("template-index");
    // Fallback: URL "/" (mit oder ohne Sprache/Prefix ist manchmal anders – Class ist zuverlässiger)
    const byPath = window.location.pathname === "/" || window.location.pathname === "";
    return byClass || byPath;
  }

  function isShopifyEditor() {
    return typeof Shopify !== "undefined" && Shopify.designMode;
  }

  function withinCooldown() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      const last = parseInt(raw, 10);
      if (!last || Number.isNaN(last)) return false;

      const ms = REPEAT_AFTER_DAYS * 24 * 60 * 60 * 1000;
      return (Date.now() - last) < ms;
    } catch (e) {
      return false;
    }
  }

  function markSeenNow() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {}
  }

  // =========================
  // ✅ Original-Funktionalität
  // =========================
  function initPVX(root) {
    if (!root || root.dataset.pvxInit === "1") return;
    root.dataset.pvxInit = "1";

    const track = root.querySelector(".pvx-track");
    const prev = root.querySelector(".pvx-prev");
    const next = root.querySelector(".pvx-next");
    if (!track) return;

    const slides = Array.from(root.querySelectorAll(".pvx-slide"));
    const vids = Array.from(root.querySelectorAll("video.pvx-video"));
    const btns = Array.from(root.querySelectorAll(".pvx-cta-btn"));
    if (slides.length === 0) return;

    const variantId = root.dataset.variantId ? parseInt(root.dataset.variantId, 10) : null;

    let activeIdx = 0;
    let inView = true; // ✅ Editor-safe: wir starten erstmal "true"
    let raf = null;

    // --- Video helpers
    function ensureInline(v) {
      try {
        v.muted = true;
        v.playsInline = true;
        v.setAttribute("muted", "");
        v.setAttribute("playsinline", "");
        v.setAttribute("webkit-playsinline", "");
      } catch (e) {}
    }

    function play(v) {
      if (!v) return;
      ensureInline(v);
      const p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function pause(v) {
      try { v.pause(); } catch (e) {}
    }

    function setActive(i) {
      slides.forEach((s, idx) => s.classList.toggle("is-active", idx === i));
    }

    function playOnly(i) {
      vids.forEach((v, idx) => {
        if (idx === i) {
          if (inView) play(v);
        } else {
          pause(v);
        }
      });
    }

    function computeActive() {
      const r = track.getBoundingClientRect();
      const center = r.left + r.width / 2;
      let best = 0, bestDist = Infinity;

      slides.forEach((s, i) => {
        const sr = s.getBoundingClientRect();
        const c = sr.left + sr.width / 2;
        const d = Math.abs(c - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function update() {
      const idx = computeActive();
      if (idx !== activeIdx) {
        activeIdx = idx;
        setActive(activeIdx);
        playOnly(activeIdx);
      }
    }

    // --- Scroll update (smooth + performant)
    track.addEventListener("scroll", function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; update(); });
    }, { passive: true });

    function scrollToIndex(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      slides[i].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }

    if (prev) prev.addEventListener("click", () => scrollToIndex(activeIdx - 1));
    if (next) next.addEventListener("click", () => scrollToIndex(activeIdx + 1));

    // --- ✅ DRAG/SWIPE Fix (funktioniert im Theme-Editor + iOS/Android)
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    function onDown(e) {
      isDown = true;
      startX = (e.touches ? e.touches[0].clientX : e.clientX);
      startScrollLeft = track.scrollLeft;
    }
    function onMove(e) {
      if (!isDown) return;
      const x = (e.touches ? e.touches[0].clientX : e.clientX);
      const dx = x - startX;
      track.scrollLeft = startScrollLeft - dx;
      if (!e.touches) e.preventDefault();
    }
    function onUp() { isDown = false; }

    // Touch
    track.addEventListener("touchstart", onDown, { passive: true });
    track.addEventListener("touchmove", onMove, { passive: false });
    track.addEventListener("touchend", onUp, { passive: true });
    track.addEventListener("touchcancel", onUp, { passive: true });

    // Mouse (Desktop Editor)
    track.addEventListener("mousedown", onDown);
    window.addEventListener("mousemove", onMove, { passive: false });
    window.addEventListener("mouseup", onUp);

    // --- ✅ Viewport observer (optional) – aber Editor-sicher
    const threshold = Math.max(0.05, Math.min(0.8, parseFloat(root.dataset.threshold || "0.25")));
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          inView = entry.isIntersecting || inView;
          if (entry.isIntersecting) {
            setActive(activeIdx);
            playOnly(activeIdx);
          } else {
            vids.forEach(pause);
          }
        });
      }, { threshold });
      io.observe(root);
    }

    // --- Init: first slide active
    setActive(0);
    ensureInline(vids[0]);
    requestAnimationFrame(() => { update(); playOnly(0); });
    setTimeout(() => { update(); playOnly(activeIdx); }, 180);

    // --- ✅ Autoplay kick
    function kick() {
      inView = true;
      playOnly(activeIdx);
      window.removeEventListener("pointerdown", kick);
      window.removeEventListener("touchstart", kick);
      window.removeEventListener("click", kick);
    }
    window.addEventListener("pointerdown", kick, { passive: true });
    window.addEventListener("touchstart", kick, { passive: true });
    window.addEventListener("click", kick, { passive: true });

    // --- Add-to-cart
    btns.forEach((btn, idx) => {
      if (!variantId) {
        btn.setAttribute("aria-disabled", "true");
        btn.addEventListener("click", (e) => { e.preventDefault(); });
        return;
      }

      btn.addEventListener("click", async (e) => {
        if (idx !== activeIdx) {
          e.preventDefault();
          scrollToIndex(idx);
          return;
        }

        e.preventDefault();
        if (btn.dataset.loading === "1") return;

        btn.dataset.loading = "1";
        const oldText = btn.textContent;

        btn.textContent = "Wird hinzugefügt…";
        btn.setAttribute("aria-disabled", "true");

        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });

          if (!res.ok) throw new Error("Konnte nicht hinzugefügt werden.");

          btn.textContent = "Hinzugefügt ✓";
          setTimeout(() => { window.location.href = "/cart"; }, 450);
        } catch (err) {
          btn.textContent = oldText;
          btn.dataset.loading = "0";
          btn.setAttribute("aria-disabled", "false");
          alert(err && err.message ? err.message : "Fehler beim Hinzufügen.");
        }
      });
    });
  }

  function boot(scope) {
    const roots = scope
      ? scope.querySelectorAll(".pvx-video-mode")
      : document.querySelectorAll(".pvx-video-mode");
    roots.forEach(initPVX);
  }

  // =========================
  // ✅ NEU: Nur Startseite + 7 Tage Cooldown
  // =========================
  function shouldRun() {
    if (isShopifyEditor()) return true; // im Editor immer laufen lassen

    if (ONLY_HOMEPAGE && !isHomePage()) return false;
    if (withinCooldown()) return false;

    return true;
  }

  function runOncePerWindowLoad() {
    if (!shouldRun()) return;

    // Wichtig: sofort markieren, damit bei schnellem Navigation/Reload nicht doppelt
    markSeenNow();

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => boot());
    } else {
      boot();
    }
  }

  runOncePerWindowLoad();

  // Theme editor
  document.addEventListener("shopify:section:load", (e) => e?.target && boot(e.target));
  document.addEventListener("shopify:section:select", (e) => e?.target && boot(e.target));
  document.addEventListener("shopify:block:select", (e) => e?.target && boot(e.target));
})();

